/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type TrucksListPageQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']
  trucksLimit: Types.InputMaybe<Types.Scalars['Int']>
  trucksOffset: Types.InputMaybe<Types.Scalars['Int']>
  foodTypeIds: Types.InputMaybe<
    Array<Types.Scalars['Int']> | Types.Scalars['Int']
  >
  minRating: Types.InputMaybe<Types.Scalars['Float']>
}>

export type TrucksListPageQuery = {
  __typename: 'Query'
  foodTypes: Array<{ __typename: 'FoodType'; id: number; name: string | null }>
  structuredData: {
    __typename: 'StructuredData'
    marketListTrucksPage: Array<string> | null
  }
  marketBySlug: {
    __typename: 'Market'
    id: number
    name: string
    customerTrucksMapPath: string
    state: string
    stateFull: string
    customerPath: string
    customerTrucksListUrl: string
    latitude: number
    longitude: number
    showMap: boolean
    image: { __typename: 'MarketImage'; medium: string }
    trucks: {
      __typename: 'TruckCollection'
      total: number
      records: Array<{
        __typename: 'Truck'
        id: number
        name: string
        scheduleUrl: string
        menus: Array<{
          __typename: 'Menu'
          id: number
          foodTypes: Array<{
            __typename: 'FoodType'
            id: number
            name: string | null
          }>
        }>
        foodImage: { __typename: 'TruckFoodImage'; medium: string } | null
        ratingInfo: {
          __typename: 'TruckRatingInfo'
          averageRating: number
          ratingsCount: number
        } | null
      }>
    }
  } | null
}

export const TrucksListPageQueryDocument = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TrucksListPageQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trucksLimit' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'trucksOffset' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'foodTypeIds' }
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'minRating' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'foodTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'structuredData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketListTrucksPage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'seoName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'slug' }
                      }
                    }
                  ]
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slug' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerTrucksMapPath' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateFull' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerPath' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customerTrucksListUrl' }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                { kind: 'Field', name: { kind: 'Name', value: 'showMap' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'medium' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'trucks' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'page' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'limit' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'trucksLimit' }
                            }
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'offset' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'trucksOffset' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'foodTypeIds' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'foodTypeIds' }
                            }
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'minRating' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'minRating' }
                            }
                          }
                        ]
                      }
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'sort' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'field' },
                            value: { kind: 'EnumValue', value: 'popularity' }
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'direction' },
                            value: { kind: 'EnumValue', value: 'desc' }
                          }
                        ]
                      }
                    }
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'records' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'scheduleUrl' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'menus' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'foodTypes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'foodImage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'medium' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ratingInfo' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'averageRating'
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'ratingsCount'
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown) as DocumentNode

/**
 * __useTrucksListPageQuery__
 *
 * To run a query within a React component, call `useTrucksListPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrucksListPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrucksListPageQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      trucksLimit: // value for 'trucksLimit'
 *      trucksOffset: // value for 'trucksOffset'
 *      foodTypeIds: // value for 'foodTypeIds'
 *      minRating: // value for 'minRating'
 *   },
 * });
 */
export function useTrucksListPageQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    TrucksListPageQuery,
    TrucksListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    TrucksListPageQuery,
    TrucksListPageQueryVariables
  >(TrucksListPageQueryDocument, options)
}
export function useTrucksListPageQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    TrucksListPageQuery,
    TrucksListPageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    TrucksListPageQuery,
    TrucksListPageQueryVariables
  >(TrucksListPageQueryDocument, options)
}
export type TrucksListPageQueryHookResult = ReturnType<
  typeof useTrucksListPageQuery
>
export type TrucksListPageQueryLazyQueryHookResult = ReturnType<
  typeof useTrucksListPageQueryLazyQuery
>
export type TrucksListPageQueryQueryResult = Apollo.QueryResult<
  TrucksListPageQuery,
  TrucksListPageQueryVariables
>
